export const LEGAL_REMINDER_FOR_BUG_REPORT =
  'The content in the downloaded file is the exclusive property of Text, Inc. and is protected under applicable law. It’s intended for use only by our Support Team and cannot be shared with third parties without our explicit consent.';
